import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';


import { AppService } from '@app/services/app/app.service';
import { Session } from '@app/store/models/session.model';
import { projectDetailsMenu } from '@app/models/menu/projects.menu';
import { AccessProject, AccessProjectKeys } from '@app/models/access';

import { UrlService } from '@core/services/url/url.service';
import { TitleService } from '@core/services/title.service'; 
import { ProjectRelatedVersionsService } from '@core/services/project-related-versions/project-related-versions.service';

;
import * as Objects from '@core/objects';
import { MenuItem } from '@core/models/menu-item.model';
import { TransferService } from '@plugins/share_transfer/src/App/services/transfer.service';


@Component({
    selector: 'plugin-share-transfer-main-app',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class PluginShareTransferMainAppComponent implements OnInit {

    readonly PLUGIN = "share_transfer";
    readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';

    public readonly SIGNATURE_OPTION_TYPE_CFR11 = 'cfr11';

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 3;

    public readonly VIEW_SELECTOR = 0;
    public readonly VIEW_SENDER = 1;
    public readonly VIEW_DONE = 2;
    public readonly VIEW_SEND_ERROR = 3;
    public readonly VIEW_SEND_NOT_ALLOWED = 4;
    public readonly VIEW_SEND_DONE = 5;

    public readonly NO_DETERMINED = 0;
    public readonly DEFAULT_MODE = 1;
    public readonly SINGLE_FILE_MODE = 2;
    public readonly SINGLE_VERSION_MODE = 3;

    public screenMode: number = this.NO_DETERMINED;
    public status: number = this.LOADING;
    public permission: boolean = true;
    public view: number = this.VIEW_SELECTOR;

    public project: Objects.Request = null;
    public partialProject: Objects.BasicRequest = null;
    public versionId: number;
    public projectId: number;
    public menuProjects: Array<MenuItem> = projectDetailsMenu;
    public fileId: number;
    public filesPluralPart: string = "";
    public signatureOption: boolean = false;
    public headerText: string = 'SELECT FILES REFERENCES';
    public breadcrumbText: string = 'SELECT ARTWORKS';
    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];


    public filesSelected: Array<Objects.File> = [];
    public form: FormGroup;

    protected user: Objects.User;
    protected organization: Objects.Organization;
    public subject: string;

    private lastSuccessfulNavigation: NavigationEnd | undefined;

    public subs = new Subscription();

    constructor(private appSrv: AppService, 
        private http: HttpClient, 
        public urlSrv: UrlService, 
        private activeRoute: ActivatedRoute, 
        private title: TitleService,
        private location: Location,
        private router: Router,
        private trasnferSrv: TransferService,
        private projectRVSrv: ProjectRelatedVersionsService) {
        // TODO: check options to select screen mode

        this.subs.add(
            this.appSrv.getSession().subscribe((session: Session) => {
                this.user = session.current.user;
                this.organization = session.current.organization;
                this.signatureOption = session?.options?.organization.version_approvals_signature_type === this.SIGNATURE_OPTION_TYPE_CFR11;

                if(session.options.plugins.indexOf(this.PLUGIN) == -1)
                    this.status = this.NOT_FOUND;

                this.projectRVSrv.initialice(session.options.plugins.indexOf(this.PLUGIN_REQUEST_FEEDBACK) != -1 || false);
            })
        );

        this.subs.add(
            this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                this.lastSuccessfulNavigation = event;
                }
            })
        );
    }

    ngOnInit() {
        // load query params to check from where user came from
        this.subs.add(
            this.activeRoute.queryParams.subscribe(params => {
                if ( params.file && params.version ) {
                    this.versionId = Number(params.version);
                    this.fileId = Number(params.file);
                    this.screenMode = this.SINGLE_FILE_MODE;
                    
                } else if( params.version ){
                    this.versionId = Number(params.version);
                    this.screenMode = this.SINGLE_VERSION_MODE;
                } else {
                    this.screenMode = this.DEFAULT_MODE;
                }
                this.initView();
                
            })
        );

        this.form =  new FormGroup({});

        this.projectId = Number(this.activeRoute.snapshot.paramMap.get('project'));

        this.title.set("Select files to send - Project #"+this.projectId);
        this.initView();
    }

    onChange(e) {
        if(e.length >=0)
            this.filesSelected = (e);
    }

    ngOnDestroy(){
        this.subs.unsubscribe();
    }

    protected initView(){
        // When no version or file in url work as default
        if((this.screenMode == this.DEFAULT_MODE || this.screenMode == this.SINGLE_VERSION_MODE ) && this.projectId){
            if(this.status != this.NOT_FOUND)
                this.loadRequest(this.projectId);
        }

        // When file & version in the url,
        // we need to check the version has this file  and then also the origin request of the version
        if( this.screenMode == this.SINGLE_FILE_MODE && this.fileId && this.versionId && this.projectId){
            if(this.status != this.NOT_FOUND)
                this.checkVersionFile(this.versionId,this.fileId);
        }
    }

    protected loadFile(fid: number) {
        this.subs.add(
            this.trasnferSrv.loadFile(fid).subscribe({
                next: (data: Objects.File) => {
                    this.filesSelected.push(data);
                    this.view = this.VIEW_SENDER;
                },
                error: (error:any) => {
                }
            })
        );
        // this.http.get(this.urlSrv.build('/files/'+fid)+"?f=json").subscribe({
        //     next: (data: Objects.File) => {
        //         this.filesSelected.push(data);
        //         this.view = this.VIEW_SENDER;
        //     },
        //     error: (error:any) => {
        //     }
        // });
    }

    protected loadRequest(projectId: number){
        this.subs.add(
            this.trasnferSrv.loadProject(projectId).subscribe({
                next: (response: HttpResponse<Objects.Request>) => {
                    if (response.status === 200) {
                        this.project = response.body as Objects.Request;
                        // Full success
                        this.updateMenu(response.body as Objects.Request)
                    } else if (response.status === 206) {
                        // Partial content: User has limited access, set project partial instead
                        this.partialProject = response.body as Objects.BasicRequest;
                    }
                    this.setProject(response.body as Objects.Request);

                    this.updateBreadcrumbs(response.body as Objects.Request);
                    this.loadRequestWithPermissions(projectId);
                },
                error: (error:any) => {
                    this.status = this.NOT_FOUND;
                }
            })
        );
    }

    /**
     * load the project and check permissions
     */
    protected loadRequestWithPermissions(projectId: number){
        this.subs.add(
            this.trasnferSrv.loadProjectPermissions(projectId).subscribe({
                next: (access: AccessProject) => {
                    if (access.hasOwnProperty(AccessProjectKeys.SEND_FILE)) {
                        this.permission = access[AccessProjectKeys.SEND_FILE];
                    }
                    this.status = this.DONE;
                },
                error: (error:any) => {
                    this.status = this.NOT_FOUND;
                }
            })
        );
    }

    // Check if the file param in url is a correct version file.
    protected checkVersionFile(versionId: number, fileId: number){

        // this.http.get(this.urlSrv.build('/versions/'+versionId+'/files')).subscribe({
        this.subs.add(
            this.trasnferSrv.loadVersionFiles(versionId).subscribe({
                next: (files: Array<Objects.File>) => {
                    if (fileId != null && !files.some((vf: Objects.File) => vf.id == fileId)){
                        this.status = this.NOT_FOUND;
                    } else {
                        this.loadFile(fileId);
                        this.loadRequest(this.projectId);
                    }
                },
                error: (error:any) => {
                    this.status = this.NOT_FOUND;
                }
            })
        );
    }

    public setView(view: number)
    {
        if (view == this.VIEW_SENDER) {
            this.breadcrumbText = 'OPTIONS';
            this.headerText = "SEND FILES";
        }
        if (view == this.VIEW_SELECTOR) {
            this.breadcrumbText = 'SELECT ARTWORKS';
            this.headerText = "SELECT FILES REFERENCES";
        }
        this.view = view;
    }

    public setProject(request: Objects.Request) {

        let labels = request.labels.map((l: Objects.Label) => l.name).join(", ");
        // update april 2024 -> Twona AMS - {User Owner name} is sending you file(s) related to {Request labels}
        // Twona AMS - prefix already set on backend
        this.subject = this.user.name +
            " is sending you file(s) related to " + labels;
    }

    public onAddSignatureChange(e) {
        // console.debug(" %%%  main transfer onSignatureChange");
    }

    public onSubmit() {
        let data = {
            type: "transfer",
            request: this.project? this.project.id : this.partialProject.id,
            files: this.filesSelected.map((f: Objects.File) => f.id),
            subject: this.form.get('subject').value,
            message: this.form.get('message').value,
            emails: this.form.get('emails').value,
            with_signatures: this.form.get('with_signatures')?.value || false, // TODO maybe quit this property when no cfr11 in org
        }
        if(data.files.length >1 ) {
            this.filesPluralPart = 's';
        }
        this.http.post(this.urlSrv.build('/share'), data).subscribe({
            next: (data: any) => {
                this.view = this.VIEW_SEND_DONE;
            },
            error: (error:any) => {
                console.log(" Error on transfer submit ", error);
                // this.status = this.NOT_FOUND;
                if(error.status == 403)
                    this.view = this.VIEW_SEND_NOT_ALLOWED;
                else
                    this.view = this.VIEW_SEND_ERROR;
            }
        });

        console.debug(" transfer submit ", data);

    }

    public cancel () {
        this.filesSelected = [];
    }
    // checks to show the button SEND
    isTransferReady () {
        return (
            this.filesSelected.length > 0 &&
            this.form.get('subject')?.value != '' &&
            this.form.get('emails')?.value?.length > 0 &&
            this.form.get('message')?.value?.length > 0
           )
    }
    // checks to show the button NEXT
    isSelectionReady() {
        return (this.filesSelected.length > 0);
    }
    // action when push modal buton when error
    onError() {
        console.debug(" Error modal clicked");
        this.view = this.VIEW_SENDER;
        this.status = this.DONE
    }

    onSent() {
        this.cancel();
        if (this.lastSuccessfulNavigation) {
            this.location.back();
        } else {
            console.debug('There is no previous navigation state.');
            this.view = this.VIEW_DONE;
        }
    }


    protected updateBreadcrumbs(project: Objects.Request) {
        this.breadcrumbs[0].link = '/projects/' + project.id;
        this.breadcrumbs[0].title = 'Project <small>(#' + project.id + ')</small>';
    }

    // with this works the selected items in nav according activeRoute.
    protected updateMenu(project: Objects.Request) {
        if (project == null)
            return;

        this.menuProjects = projectDetailsMenu.map((item: MenuItem) => {
            return { ...item, link: item.link.replace(':id', project.id.toString()) }
        });
    }



}
